'use client';
import React, { useEffect, useState } from 'react';

interface NaverMapProps {
  lat: number;
  lng: number;
  width?: string | number;
  height?: string | number;
  zoom?: number;
  className?: string;
}

/**
 * Naver Map component for web
 * Updated to use the latest react-naver-maps API
 */
const NaverMap: React.FC<NaverMapProps> = ({
  lat,
  lng,
  width = '100%',
  height = 300,
  zoom = 16,
  className = '',
}) => {
  const [retryCount, setRetryCount] = useState(0);

  useEffect(() => {
    //@ts-ignore
    if(typeof naver === 'undefined') {
      // 네이버 지도 20번 까지 재시도
      if(retryCount > 20) return;
      setTimeout(() => setRetryCount(retryCount + 1), 50);
      return;
    }

    //@ts-ignore
    const position = new naver.maps.LatLng(lat, lng);
    const mapOptions = {
      center: position,
      zoom: zoom
    };
    //@ts-ignore
    const map = new naver.maps.Map('naver-map', mapOptions);
    //@ts-ignore
    const marker = new naver.maps.Marker({ position: position, map: map });
  }, [lat, lng, zoom, retryCount]);

  return (
    <div id='naver-map' className={className} style={{ width, height }}/>
  );
};

export default NaverMap;
